<ion-grid style="height:inherit">
  <ion-row style="height:100%">
    <ion-col>
      <ion-content [scrollEvents]="false" class="modal">
        <ion-item color="primary" class="header" lines="none">
          <ng-content select="[modal-header]"></ng-content>
        </ion-item>
        <div class="body">
          <ng-content select="[modal-body]"></ng-content>
        </div>
      </ion-content>
    </ion-col>
  </ion-row>
</ion-grid>

